<template lang="pug">
.c-workflows-content
  //- Teleport button to parent nav actions
  teleport(to="#resource-actions-portal" v-if="mounted")
    el-button(type="primary" @click="dialog=true")
      fai(type="fal" icon="plus-circle")
      span Add New

  //- Table Section
  section.c-workflows-table-section
    el-table(
      :data="items.items"
      v-loading="loading"
      @row-click="$router.push(`workflows/${$event.id}`);"
      style="width: 100%"
    ).clickable-rows
      el-table-column(width="15")
      el-table-column(label="Title" prop="title")
      el-table-column(width="46")
        template(#default)
          .el-table__expand-icon
            img(src="@/assets/icons/light/chevron-right-light.svg")
      el-table-column(width="15")

  DialogAddWorkflow(
    v-if="dialog"
    :loading="loading"
    v-model="dialog"
    @save-item="saveWorkflow($event)"
    @close-dialog="dialog = false"
  )
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from 'vue';
import DialogAddWorkflow from './DialogAddWorkflow.vue';
import shared from '../shared';

export default defineComponent({
  name: 'Workflows',
  components: { DialogAddWorkflow },
  setup() {
    const {
      doFindWorkflows,
      doMutateWorkflow,
      loading,
      dialog,
    } = shared();
    const mounted = ref(false);
    const items = reactive({ items: [] });
    async function getItems() {
      try {
        loading.value = true;
        items.items = await doFindWorkflows();
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
      }
    }
    async function saveWorkflow(item: any) {
      await doMutateWorkflow(item);
      await getItems();
    }
    onMounted(async () => {
      await getItems();
      mounted.value = true;
    });
    return {
      mounted,
      items,
      loading,
      dialog,
      saveWorkflow,
    };
  },
});

</script>

<style lang="scss" scoped>
@import '@/views/manage-users-and-organizations/crm-list';

.c-workflows-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@include crm-table('c-workflows-table-section');

.c-workflows-table-section :deep(.el-table__expand-icon) {
  display: flex;
  align-items: center;
  height: 20px;
}

.c-workflows-table-section :deep(.clickable-rows .el-table__row:hover > td.el-table__cell) {
  background-color: rgba($muted, 0.5);
}
</style>
